import { DataProvider, DeleteParams, GetManyReferenceParams, UpdateManyParams } from "react-admin";

import http from "../auth/http-common";

const getList = async (path: string, { pagination, sort, filter }: any): Promise<any> => {
  const offset = (pagination.page - 1) * pagination.perPage;
  let url = `/${path}?page=${offset}&limit=${pagination.perPage}`;
  if (sort) url += `&sort=${sort.field}&order=${sort.order}`;
  if (filter?.q) url += `&search=${encodeURIComponent(filter.q)}`;
  const response = await http.get(url, { proxy: false });
  return { data: response.status === 200 ? response?.data?.items : [], total: response?.data?.count };
};

// eslint-disable-next-line consistent-return
const getOne = async (path: string, params: any): Promise<any> => {
  const response = await http.get(`/${path}/${params.id}`, { proxy: false });
  if (response.status === 200) {
    // eslint-disable-next-line no-underscore-dangle
    return { data: { ...(response?.data || []), id: response.data.id } };
  }
};

// eslint-disable-next-line consistent-return
const create = async (path: string, data: any): Promise<any> => {
  let response;
  if (path === "users" || path === "admins") {
    response = await http.post(`/${path}/invite`, data.data, { proxy: false });
  } else {
    response = await http.post(`/${path}`, data.data, { proxy: false });
  }
  if (response.status === 201) {
    // eslint-disable-next-line no-underscore-dangle
    return { data: { ...response?.data, id: response.data._id } };
  }
};

// eslint-disable-next-line consistent-return
const update = async (path: string, data: any): Promise<any> => {
  delete data.data.id;

  delete data.data.updated_at;
  delete data.data.created_at;

  if (path === "users") {
    if (data.data.email === data.data.initial_email) {
      delete data.data.email;
    }
    delete data.data.initial_email;

    delete data.data.avatar;

    delete data.data.confirmed_at;
  }

  if (path === "organizations") {
    delete data.data.logo;
    if (data.data.locations) delete data.data.locations;
    data.data.members.forEach((member: { organization: unknown; locations: unknown }) => {
      if (member.organization) delete member.organization;
      if (member.locations) delete member.locations;
    });
  }

  const response = await http.put(`/${path}/${data.id}`, data.data, { proxy: false });
  if (response.status === 200) {
    // eslint-disable-next-line no-underscore-dangle
    return { data: { ...response?.data, id: response.data._id } };
  }
};

// eslint-disable-next-line consistent-return
const deleteOne = async (path: string, params: any): Promise<any> => {
  const response = await http.delete(`/${path}/${params.id}`, { proxy: false });
  if (response.status === 200) {
    // eslint-disable-next-line no-underscore-dangle
    return { data: { ...response?.data.message } };
  }
};

// eslint-disable-next-line consistent-return
const deleteMany = async (path: string, params: any): Promise<any> => {
  const response = await http.delete(`/${path}/delete`, { proxy: false, data: { ids: params.ids } });
  if (response.status === 200) {
    return { data: params.ids };
  }
};

// eslint-disable-next-line consistent-return
const getMany = async (path: string, params: any): Promise<any> => {
  const response = await http.post(`/${path}/many`, { ids: params.ids }, { proxy: false, data: { ids: params.ids } });
  if (response.status === 200) {
    return { data: response?.data || [], total: response?.data.length };
  }
};

const getManyReference = async (resource: string, params: GetManyReferenceParams): Promise<any> => {
  return [];
};
const updateMany = async (resource: string, params: UpdateManyParams<any>): Promise<any> => {
  return [];
};

const deleteProvider = async (resource: string, params: DeleteParams<any>): Promise<any> => {
  return [];
};

export const dataProvider: DataProvider = {
  create,
  delete: deleteOne,
  deleteMany,
  deleteOne,
  getList,
  getMany,
  getManyReference,
  getOne,
  update,
  updateMany,
};
